import type { PlpConfig } from '#types/config/pages/plp'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    categoryTitle: 'title-2 lg:mt-2',
    eSpotLazyAboveFooter: 'my-16 [&_.container]:px-0'
  },
  eSpotsWithPageContext: ['lazy-above-footer'],
  sorts: () => ({
    NORA: [
      'bestMatches',
      'priceLowToHigh',
      'priceHighToLow',
      'rating'
    ],
    EMEA: [
      'bestMatches',
      'priceLowToHigh',
      'priceHighToLow',
      'rating',
      'topSellers',
      'whatsNew'
    ]
  })
} satisfies RecursivePartial<PlpConfig>
